/**
 * Decide whether the status-batch epic may auto-recover a failed investigation.
 *
 * Status batch has no failure reason, so we cannot tell a 402 from a transient
 * fail from the API alone. Recover only on a live transition into `failed`
 * while viewing, and never when credits are known-blocked (IC-49715 / IC-49442).
 */
export const shouldAutoRecoverFailedInvestigation = ({
  previousStatus,
  isViewing,
  insufficientCredits,
  creditsExhausted,
}) => {
  if (!isViewing) return false
  // Sticky `failed` after refresh / first poll: previous is undefined.
  // Already-failed sticky polls: previous stays `failed`. Neither is a live fail.
  if (previousStatus === undefined || previousStatus === 'failed') return false
  if (insufficientCredits || creditsExhausted) return false
  return true
}
